import { Button } from "@mui/material";
import styled from "styled-components";
import colors from "../../styles/colors";

export const ButtonInverse = styled(Button)`
  border-radius: 30px !important;
  padding: 8px 70px !important;
  width: auto;
  background-color: ${colors.IceBlue} !important;
  color: ${colors.IceWhite} !important;
  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background-color: ${colors.WaterBlue} !important;
  }

  &:disabled {
    background-color: ${colors.LowBlue} !important;
    color: ${colors.FogGray} !important;
    border: ${colors.LowBlue} solid 2px !important;
    cursor: not-allowed !important;
  }
`;